var __decorate=this&&this.__decorate||function(t,e,i,a){var o,r=arguments.length,l=r<3?e:null===a?a=Object.getOwnPropertyDescriptor(e,i):a;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(t,e,i,a);else for(var n=t.length-1;n>=0;n--)(o=t[n])&&(l=(r<3?o(l):r>3?o(e,i,l):o(e,i))||l);return r>3&&l&&Object.defineProperty(e,i,l),l},__awaiter=this&&this.__awaiter||function(t,e,i,a){return new(i||(i=Promise))(function(o,r){function l(t){try{s(a.next(t))}catch(t){r(t)}}function n(t){try{s(a.throw(t))}catch(t){r(t)}}function s(t){var e;t.done?o(t.value):((e=t.value)instanceof i?e:new i(function(t){t(e)})).then(l,n)}s((a=a.apply(t,e||[])).next())})};import{css as t,html as e,unsafeCSS as i}from"lit";import{OrElement as a}from"@openremote/or-element";import{customElement as o,property as r,state as l}from"lit/decorators.js";import{classMap as n}from"lit/directives/class-map.js";import{until as s}from"lit/directives/until.js";import{MDCDataTable as c}from"@material/data-table";import{when as d}from"lit/directives/when.js";import{DefaultColor3 as h,DefaultColor2 as u,DefaultColor1 as m}from"@openremote/core";import{i18next as p}from"@openremote/or-translate";import{InputType as b}from"./or-mwc-input";import{styleMap as w}from"lit/directives/style-map.js";import g from"moment";let dataTableStyle=require("@material/data-table/dist/mdc.data-table.css"),style=t`
  :host {
    width: 100%;
  }

  :host([hidden]) {
    display: none;
  }

  .mdc-data-table {
    width: 100%;
    overflow: auto;
    max-height: 500px;
  }

  .mdc-data-table__paginated {
    overflow: hidden;
    max-height: 700px;
    justify-content: space-between;
  }

  .mdc-data-table__fullheight {
    height: 100%;
    max-height: none !important;
  }

  /* first column should be sticky*/
  .mdc-data-table.has-sticky-first-column tr th:first-of-type,
  .mdc-data-table.has-sticky-first-column tr td:first-of-type {
    z-index: 1;
    position: sticky;
    left: 0;
    background-color: ${i(u)};
  }

  .mdc-data-table.has-sticky-first-column tr th:first-of-type {
    z-index: 2;
  }

  thead th {
    box-shadow: 0 1px 0 0 rgb(229, 229, 229);
  }

  .mdc-data-table.has-sticky-first-column tr td:first-of-type {
    box-shadow: 1px 0 0 0 rgb(229, 229, 229);
  }

  thead th:first-of-type {
    box-shadow: 1px 1px 0 0 rgb(229, 229, 229);
  }

  th {
    position: sticky;
    top: 0;
    background-color: ${i(m)};
  }

  th,
  td {
    cursor: default;
  }

  .mdc-data-table__header-cell {
    font-weight: bold;
    color: ${i(h)};
    font-size: 14px;
  }

  .mdc-data-table__pagination-rows-per-page-select {
    /*min-width: 112px;*/
  }

  .mdc-data-table__pagination {
    min-height: 64px;
  }

  .mdc-data-table__cell--clickable {
    cursor: pointer;
  }

  .sort-button {
    padding-right: 0;
    border: none;
    color: ${i(h)};
    background-color: transparent;
    cursor: pointer;
  }

  .sort-button-reverse {
    padding-left: 0;
    border: none;
    color: ${i(h)};
    cursor: pointer;
  }

  .sortable {
    flex-direction: row;
    cursor: pointer;
  }

  .sortable-reverse {
    flex-direction: row-reverse;
    cursor: pointer;
  }

  .hidden {
    visibility: hidden;
  }

  #column-1 {
    width: var(--or-mwc-table-column-width-1, unset);
  }
  #column-2 {
    width: var(--or-mwc-table-column-width-2, unset);
  }
  #column-3 {
    width: var(--or-mwc-table-column-width-3, unset);
  }
  #column-4 {
    width: var(--or-mwc-table-column-width-4, unset);
  }
  #column-5 {
    width: var(--or-mwc-table-column-width-5, unset);
  }
  #column-6 {
    width: var(--or-mwc-table-column-width-6, unset);
  }
  #column-7 {
    width: var(--or-mwc-table-column-width-7, unset);
  }
  #column-8 {
    width: var(--or-mwc-table-column-width-8, unset);
  }
  #column-9 {
    width: var(--or-mwc-table-column-width-9, unset);
  }
  #column-10 {
    width: var(--or-mwc-table-column-width-10, unset);
  }

  @media screen and (max-width: 768px) {
    .hide-mobile {
      display: none;
    }
  }
`;export class OrMwcTableRowClickEvent extends CustomEvent{constructor(t){super(OrMwcTableRowClickEvent.NAME,{detail:{index:t},bubbles:!0,composed:!0})}}OrMwcTableRowClickEvent.NAME="or-mwc-table-row-click";export class OrMwcTableRowSelectEvent extends CustomEvent{constructor(t,e){super(OrMwcTableRowSelectEvent.NAME,{detail:{index:t,state:e},bubbles:!0,composed:!0})}}OrMwcTableRowSelectEvent.NAME="or-mwc-table-row-select";let OrMwcTable=class extends a{constructor(){super(...arguments),this.config={columnFilter:[],stickyFirstColumn:!0,fullHeight:!1,pagination:{enable:!1}},this.paginationIndex=0,this.paginationSize=10,this.sortDirection="ASC",this.sortIndex=-1,this.selectedRows=[]}static get styles(){return[t`
        ${i(dataTableStyle)}
      `,style]}firstUpdated(t){let e=this.shadowRoot.querySelector(".mdc-data-table");this._dataTable=new c(e)}updated(t){var e;if((t.has("paginationIndex")||t.has("paginationSize"))&&(null==(e=this.config.pagination)?void 0:e.enable)){let t=this._dataTable?this._dataTable.root.children[0]:this.shadowRoot.querySelector(".mdc-data-table__table-container");new IntersectionObserver((t,e)=>{t[0].target.scrollTop=0,e.unobserve(t[0].target)}).observe(t),this.selectedRows=[]}}render(){var t,i,a,o,r,l,c,h;let u={"mdc-data-table":!0,"mdc-data-table__paginated":!!(null==(t=this.config.pagination)?void 0:t.enable),"mdc-data-table__fullheight":!!this.config.fullHeight,"has-sticky-first-column":!!this.config.stickyFirstColumn},m=(null==(i=this.config.pagination)?void 0:i.options)||[10,25,100],g=Math.min(...m,this.paginationSize),v=(null==(a=this.config.pagination)?void 0:a.enable)&&(!!this.rowsTemplate||(null!=(l=null!=(o=this.totalCount)?o:null==(r=this.rows)?void 0:r.length)?l:0)>g),_=null==(h=null==(c=this.shadowRoot)?void 0:c.firstElementChild)?void 0:h.clientWidth;return e`
      <div class="${n(u)}">
        <div class="mdc-data-table__table-container" style="flex: 1;">
          <table class="mdc-data-table__table">
            <!-- Header row that normally includes entries like 'id' and 'name'. You can use either a template or a list of columns -->
            ${d(this.columnsTemplate,()=>this.columnsTemplate,()=>this.columns?e`
                      <thead>
                        <tr class="mdc-data-table__header-row">
                          ${this.columns.map((t,i)=>{var a,o;let r={width:this.getColumnWidth(i,this.columns,_),maxWidth:this.getMaxColumnWidth(i,this.columns,_)};if(0===i&&this.config.multiSelect){let r=this.rows&&this.rows.length>0&&(null==(a=this.selectedRows)?void 0:a.length)===(null==(o=this.rows)?void 0:o.length),l=!r&&this.selectedRows&&this.selectedRows.length>0;return e` <th
                                  class="mdc-data-table__header-cell mdc-data-table__header-cell--checkbox"
                                  role="columnheader"
                                  scope="col"
                                >
                                  <or-mwc-input
                                    type="${b.CHECKBOX}"
                                    id="checkbox"
                                    .indeterminate="${l}"
                                    .value="${r}"
                                    @or-mwc-input-changed="${t=>this.onCheckChanged(t,t.detail.value,"all")}"
                                  >
                                  </or-mwc-input>
                                </th>
                                ${"string"==typeof t?e`
                                        <th
                                          class="mdc-data-table__header-cell ${this.config.multiSelect?"mdc-data-table__header-cell":""}"
                                          id="column-${i+1}"
                                          role="columnheader"
                                          scope="col"
                                          title="${t}"
                                        >
                                          column
                                        </th>
                                      `:e`
                                        <th
                                          class="mdc-data-table__header-cell ${n({"mdc-data-table__cell--numeric":!!t.isNumeric,"hide-mobile":!!t.hideMobile,"mdc-data-table__header-cell--with-sort":!!t.isSortable})}"
                                          role="columnheader"
                                          scope="col"
                                          title="${t.title}"
                                          data-column-id="${t.title}"
                                          @click="${e=>t.isSortable?this.onColumnSort(e,i,this.sortDirection):""}"
                                        >
                                          ${!t.isSortable?t.title:s(this.getSortHeader(i,t.title,this.sortDirection),e`${p.t("loading")}`)}
                                        </th>
                                      `}`}return"string"==typeof t?e`
                                  <th
                                    class="mdc-data-table__header-cell ${this.config.multiSelect?"mdc-data-table__header-cell":""}"
                                    id="column-${i+1}"
                                    role="columnheader"
                                    scope="col"
                                    title="${t}"
                                  >
                                    ${t}
                                  </th>
                                `:e`
                                  <th
                                    class="mdc-data-table__header-cell ${n({"mdc-data-table__cell--numeric":!!t.isNumeric,"hide-mobile":!!t.hideMobile,"mdc-data-table__header-cell--with-sort":!!t.isSortable})}"
                                    style="${w(r)}"
                                    role="columnheader"
                                    scope="col"
                                    title="${t.title}"
                                    data-column-id="${t.title}"
                                    @click="${e=>t.isSortable?this.onColumnSort(e,i,this.sortDirection?this.sortDirection:"ASC"):""}"
                                  >
                                    ${!t.isSortable?t.title:s(this.getSortHeader(i,t.title,this.sortDirection,!!t.isNumeric),e`${p.t("loading")}`)}
                                  </th>
                                `})}
                        </tr>
                      </thead>
                    `:void 0)}
            <!-- Table content, where either the template or an array of rows is displayed -->
            <tbody class="mdc-data-table__content">
              ${d(this.rowsTemplate,()=>{var t;return(null==(t=this.config.pagination)?void 0:t.enable)&&this.updateComplete.then(()=>__awaiter(this,void 0,void 0,function*(){let t=yield this.getTableElem(!1),e=null==t?void 0:t.querySelectorAll("tr");null==e||e.forEach((t,e)=>{let i=(e<=this.paginationIndex*this.paginationSize||e>this.paginationIndex*this.paginationSize+this.paginationSize)&&!t.classList.contains("mdc-data-table__header-row");t.style.display=i?"none":"table-row"})})),e`${this.rowsTemplate}`},()=>this.rows?this.rows.filter((t,e)=>{var i;return!(null==(i=this.config.pagination)?void 0:i.enable)||e>=this.paginationIndex*this.paginationSize&&e<this.paginationIndex*this.paginationSize+this.paginationSize}).map(t=>{let i=Array.isArray(t)?t:t.content;return e`
                            <tr class="mdc-data-table__row" @click="${e=>this.onRowClick(e,t)}">
                              ${null==i?void 0:i.map((i,a)=>{let o={"mdc-data-table__cell":!0,"mdc-data-table__cell--numeric":"number"==typeof i,"mdc-data-table__cell--clickable":!Array.isArray(t)&&t.clickable,"hide-mobile":this.columns&&"string"!=typeof this.columns[a]&&this.columns[a].hideMobile},r={maxWidth:this.getMaxColumnWidth(a,this.columns,_)};return e`
                                  ${d(0===a&&this.config.multiSelect,()=>{var i;return e`
                                      <td class="mdc-data-table__cell mdc-data-table__cell--checkbox">
                                        <div class="">
                                          <or-mwc-input
                                            type="${b.CHECKBOX}"
                                            id="checkbox-${a}"
                                            @or-mwc-input-changed="${e=>this.onCheckChanged(e,e.detail.value,"single",t)}"
                                            .value="${null==(i=this.selectedRows)?void 0:i.includes(t)}"
                                          ></or-mwc-input>
                                        </div>
                                      </td>
                                    `})}
                                  <td
                                    class="${n(o)}"
                                    title="${"object"==typeof i?"":i}"
                                    style="${w(r)}"
                                  >
                                    ${s(this.getTableContent(i))}
                                  </td>
                                `})}
                            </tr>
                          `}):void 0)}
            </tbody>
          </table>
        </div>
        <!-- Pagination HTML, shown on the bottom right. Same as Material Design spec -->
        ${d(v,()=>e`
            <div class="mdc-data-table__pagination">
              <div class="mdc-data-table__pagination-trailing">
                <div class="mdc-data-table__pagination-rows-per-page">
                  <div class="mdc-data-table__pagination-rows-per-page-label">${p.t("rowsPerPage")}</div>
                  <or-mwc-input
                    class="mdc-data-table__pagination-rows-per-page-select"
                    .type="${b.SELECT}"
                    compact
                    comfortable
                    outlined
                    .readonly="${1===m.length}"
                    .value="${this.paginationSize}"
                    .options="${m}"
                    @or-mwc-input-changed="${t=>{this.paginationSize=t.detail.value,this.paginationIndex=0}}"
                  ></or-mwc-input>
                </div>
                ${s(this.getPaginationControls(),e`${p.t("loading")}`)}
              </div>
            </div>
          `)}
      </div>
    `}getTableContent(t){return"string"==typeof t||"number"==typeof t?t:t instanceof Date?g(t).format("lll"):t}onRowClick(t,e){if(this.config.multiSelect){let e=t.target;if("OR-MWC-INPUT"===e.nodeName&&e.id.includes("checkbox"))return}this.dispatchEvent(new OrMwcTableRowClickEvent(this.rows.indexOf(e)))}onCheckChanged(t,e,i,a){var o,r,l;if(t.stopPropagation(),"all"===i)e?this.selectedRows=this.rows:this.selectedRows=[],null==(o=this.rows)||o.forEach((t,i)=>this.dispatchEvent(new OrMwcTableRowSelectEvent(i,e)));else{e?void 0===this.selectedRows?this.selectedRows=[a]:-1===this.selectedRows.indexOf(a)&&(this.selectedRows.push(a),this.requestUpdate("selectedRows")):this.selectedRows=null==(r=this.selectedRows)?void 0:r.filter(t=>t!==a);let t=null==(l=this.rows)?void 0:l.indexOf(a);void 0!==t&&t>-1&&this.dispatchEvent(new OrMwcTableRowSelectEvent(t,e))}}onColumnSort(t,e,i){return __awaiter(this,void 0,void 0,function*(){if(this.config.multiSelect){let e=t.target;if("OR-MWC-INPUT"===e.nodeName&&e.id.includes("checkbox"))return}let a="ASC"==i?"DESC":"ASC";this.sortDirection=a,this.sortIndex=e,this.rows&&this.rows.length>0&&(Array.isArray(this.rows[0])?this.rows.sort((t,i)=>this.sortPrimitiveRows(t,i,e,a)):this.rows.sort((t,i)=>this.sortObjectRows(t,i,e,a)))})}sortPrimitiveRows(t,e,i,a){let o=t[i],r=e[i];if(!o&&!r)return 0;if(!o||0===o.toString().length)return"DESC"===a?1:-1;if(!r||0===r.toString().length)return"DESC"===a?-1:1;if("string"==typeof o&&"string"==typeof r)if("DESC"===a)return r.localeCompare(o,"en",{numeric:!0});else return o.localeCompare(r,"en",{numeric:!0});if("number"!=typeof o||"number"!=typeof r)return console.warn("sortPrimitiveRows() was called using neither a number nor a string."),1;else if("DESC"===a)return o>r?-1:1;else return o>r?1:-1}sortObjectRows(t,e,i,a){var o,r;let l=null==(o=t.content)?void 0:o[i],n=null==(r=e.content)?void 0:r[i],s=t=>"string"==typeof t||"number"==typeof t,c=t=>void 0!==t.strings&&void 0!==t.values;return!l||!n||s(l)||s(n)?this.sortPrimitiveRows([l],[n],0,a):l instanceof Date&&n instanceof Date?this.sortDateRows(l,n,0,a):c(l)||c(n)?this.sortTemplateRows(l,n,0,a):1}sortDateRows(t,e,i,a){return"DESC"===a?t>e?-1:1:t>e?1:-1}sortTemplateRows(t,e,i,a){var o,r;let l=null==(o=t.values.filter(t=>"string"==typeof t||"number"==typeof t).map(t=>t.toString()))?void 0:o[0],n=null==(r=e.values.filter(t=>"string"==typeof t||"number"==typeof t).map(t=>t.toString()))?void 0:r[0];return void 0!==l&&void 0!==n?this.sortPrimitiveRows([l],[n],0,a):1}getSortHeader(t,i,a){return __awaiter(this,arguments,void 0,function*(t,i,a,o=!1){return -1===this.sortIndex&&(this.sortIndex=t),e`
      <div class="mdc-data-table__header-cell-wrapper ${o?"sortable-reverse":"sortable"}">
        <div class="mdc-data-table__header-cell-label">${i}</div>
        <button
          class="mdc-icon-button material-icons ${o?"sort-button-reverse":"sort-button"} ${this.sortIndex===t?"":"hidden"}"
          aria-label="Sort by ${i}"
          aria-describedby="${i}-status-label"
          aria-hidden="${this.sortIndex!==t}"
        >
          <or-icon icon="${"ASC"==a?"arrow-up":"arrow-down"}"></or-icon>
        </button>
        <div class="mdc-data-table__sort-status-label" aria-hidden="true" id="${i}-status-label"></div>
      </div>
    `})}getPaginationControls(){return __awaiter(this,void 0,void 0,function*(){return this.renderPaginationControls(this.paginationIndex,t=>{this.paginationIndex=t})})}renderPaginationControls(t,i){return __awaiter(this,void 0,void 0,function*(){let a=yield this.getRowCount(),o=t*this.paginationSize+1,r=Math.min(t*this.paginationSize+this.paginationSize,a),l=0===t,n=r>=a,s=Math.max(0,Math.ceil(a/this.paginationSize)-1);return e`
      <div class="mdc-data-table__pagination-navigation">
        <div class="mdc-data-table__pagination-total">
          <span>${o}-${r} of ${a}</span>
        </div>
        <or-mwc-input
          class="mdc-data-table__pagination-button"
          .type="${b.BUTTON}"
          data-first-page="true"
          icon="page-first"
          .disabled="${l}"
          @or-mwc-input-changed="${()=>i(0)}"
        ></or-mwc-input>
        <or-mwc-input
          class="mdc-data-table__pagination-button"
          .type="${b.BUTTON}"
          data-prev-page="true"
          icon="chevron-left"
          .disabled="${l}"
          @or-mwc-input-changed="${()=>i(t-1)}"
        ></or-mwc-input>
        <or-mwc-input
          class="mdc-data-table__pagination-button"
          .type="${b.BUTTON}"
          data-next-page="true"
          icon="chevron-right"
          .disabled="${n}"
          @or-mwc-input-changed="${()=>i(t+1)}"
        ></or-mwc-input>
        <or-mwc-input
          class="mdc-data-table__pagination-button"
          .type="${b.BUTTON}"
          data-last-page="true"
          icon="page-last"
          .disabled="${n}"
          @or-mwc-input-changed="${()=>i(s)}"
        ></or-mwc-input>
      </div>
    `})}getRowCount(){return __awaiter(this,arguments,void 0,function*(t=!0,e){var i,a;return(null==(i=this.rows)?void 0:i.length)?null==(a=this.rows)?void 0:a.length:(e||(e=yield this.getTableElem(t)),(null==e?void 0:e.querySelectorAll("tr")).length)})}getTableElem(){return __awaiter(this,arguments,void 0,function*(t=!1){return t&&(yield this.updateComplete),this._dataTable?this._dataTable.root:this.shadowRoot.querySelector(".mdc-data-table")})}getColumnWidth(t,e,i){}getMaxColumnWidth(t,e,i){}};__decorate([r({type:Array})],OrMwcTable.prototype,"columns",void 0),__decorate([r({type:Object})],OrMwcTable.prototype,"columnsTemplate",void 0),__decorate([r({type:Array})],OrMwcTable.prototype,"rows",void 0),__decorate([r({type:Object})],OrMwcTable.prototype,"rowsTemplate",void 0),__decorate([r({type:Array})],OrMwcTable.prototype,"config",void 0),__decorate([r({type:Number})],OrMwcTable.prototype,"paginationIndex",void 0),__decorate([r({type:Number})],OrMwcTable.prototype,"paginationSize",void 0),__decorate([r({type:Number})],OrMwcTable.prototype,"totalCount",void 0),__decorate([l()],OrMwcTable.prototype,"_dataTable",void 0),__decorate([r({type:String})],OrMwcTable.prototype,"sortDirection",void 0),__decorate([r({type:Number})],OrMwcTable.prototype,"sortIndex",void 0),__decorate([r({type:Array})],OrMwcTable.prototype,"selectedRows",void 0),OrMwcTable=__decorate([o("or-mwc-table")],OrMwcTable);export{OrMwcTable};